import { Databeat as DatabeatRpc } from './databeat.gen'
export type { EventType, Event, Device, RawEvent } from './databeat.gen'

export interface Auth {
  jwt?: string
  headers?: { [key: string]: string }
}

export class DatabeatRpcClient extends DatabeatRpc {
  private _globalFetch: any

  constructor(hostname: string, public auth?: Auth) {
    const globalFetch = globalThis.fetch.bind(globalThis)

    super(hostname.endsWith('/') ? hostname.slice(0, -1) : hostname, globalFetch)

    this._globalFetch = globalFetch
    this.fetch = this._fetch
  }

  _fetch = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    // automatically include jwt auth header to requests
    // if its been set on the api client
    if (this.auth) {
      let headers: { [key: string]: any } = {}
      if (this.auth.jwt?.length > 0) {
        headers['Authorization'] = `BEARER ${this.auth.jwt}`
      }

      // set other custom auth headers
      if (this.auth.headers) {
        headers = { ...headers, ...this.auth.headers }
      }

      // before the request is made
      init!.headers = { ...init!.headers, ...headers }
    }

    return this._globalFetch(input, init)
  }
}
